"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../../../composite/table/table-cells");
const authored_columns_1 = require("../../../../composite/evidence-2/authored-evidence/authored-columns");
const table_filter_cells_1 = require("../../../../composite/table/table-filter-cells");
const common_types_1 = require("../../../../common/common-types");
const messages_api_1 = require("./messages-api");
function useColumns(webServiceUrl) {
    const intl = react_intl_1.useIntl();
    const { authoredColumns } = authored_columns_1.useAuthoredColumns();
    const { useMessageServices, useMessageOperations } = messages_api_1.createMessageHooks(webServiceUrl);
    return [
        {
            datakey: 'service',
            name: intl.formatMessage({
                id: 'EAS_SOAP_LOGGER_MESSAGES_COLUMN_SERVICE',
                defaultMessage: 'Služba',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(useMessageServices),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(useMessageServices),
            filterOperation: common_types_1.ApiFilterOperation.EQ,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'localPart',
            name: intl.formatMessage({
                id: 'EAS_SOAP_LOGGER_MESSAGES_COLUMN_LOCAL_PART',
                defaultMessage: 'Operace',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(useMessageOperations),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(useMessageOperations),
            filterOperation: common_types_1.ApiFilterOperation.EQ,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'duration',
            name: intl.formatMessage({
                id: 'EAS_SOAP_LOGGER_MESSAGES_COLUMN_DURATION',
                defaultMessage: 'Trvání',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.NumberCell,
            sortable: true,
            filterable: true,
        },
        ...authoredColumns,
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=messages-columns.js.map